module.exports = __webpack_public_path__ + "static/hardware-mobile-c251e66a47c83ce9cad638fce56e34b5.jpg";